/**
 * Ryan O'Dowd
 * 2025-05-09
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router';

export default {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
  useRoute: () => ({}),
};
